import { useAuth } from './auth-context'
import { rules } from './access-rules'
import React from 'react'

type RbacContextValue = {
  hasPermissions: (allowerPermissions: string[]) => boolean
}

type RbacProviderProps = {
  value?: RbacContextValue
  children: React.ReactNode
}

const RbacContext = React.createContext<RbacContextValue | undefined>(undefined)

const RbacProvider = (props: RbacProviderProps): JSX.Element => {
  const { user } = useAuth()

  const userPermissions: string[] =
    user && user.roles
      ? user.roles.reduce((prev: string[], curr: string) => {
          return [...prev, ...(rules[curr] || [])]
        }, [])
      : []

  const hasPermissions = (allowedPermissions: string[]) => {
    if (allowedPermissions.length === 0) {
      return true
    }

    return userPermissions.some((permission: string) => allowedPermissions.includes(permission))
  }

  return <RbacContext.Provider value={{ hasPermissions }} {...props} />
}

const useAccess = (): RbacContextValue => {
  const context = React.useContext(RbacContext)
  if (context === undefined) {
    throw new Error(`useAccess must be used within a RbacProvider`)
  }
  return context
}

export { RbacProvider, useAccess }
